import React from "react";
import { Tooltip } from "@mui/material";

/** Marks a request the agency created and delivered in one step (requested_via = agency_direct). */
const DirectChip = ({ label = "Direct" }) => (
  <Tooltip title="Delivered without request" arrow>
    <span className="mr-1 inline-flex items-center rounded border border-violet-200 bg-violet-50 px-[2px] text-[8px] font-semibold uppercase leading-2 tracking-wide text-violet-700">
      {label}
    </span>
  </Tooltip>
);

export default DirectChip;
